import {IAvailablePromotionsDTO, IProductPromotionDTO} from "@/interface";
import {IPromotionsTotals, IRadioGroupPromotion} from "@/interface/services"

export class PromotionByProductCustomer {
    public productId: number;
    public productName: string;
    public promotions: IAvailablePromotionsDTO[];
    public totals: IPromotionsTotals

    constructor(base?: Partial<PromotionByProductCustomer>){
        if (base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: IProductPromotionDTO) {
        return new PromotionByProductCustomer({
            productId: dto.product_id,
            productName: dto.product,
            promotions: dto.available_promotions,
            totals: dto.totals
        });
    }

    public radioGroupPromotion(productPrice: number): IRadioGroupPromotion {
        const descriptions = this.promotions.map((promo) => promo.promotion.descriptions);
        const promotionsTotal  = this.totals ?
            (productPrice * this.totals.percentage?.factor ?? 1) - this.totals.amount?.quantity ?? 0 :
            productPrice;
        return {
            price: productPrice,
            promo: true,
            promoPrice: promotionsTotal,
            description: descriptions
        }
    }
}